import React from 'react';
import { SubscriptionCard } from './subscription-card';
import * as ST from './styled';
import { sectionData } from './section-data';

export const Videoteka = () => {
    return (
            <ST.SubscriptionWrapper>
                <ST.GridConteiner>
                    {sectionData.map(cardData => {
                        return <SubscriptionCard key={cardData.id} data={cardData} />;
                    })}
                </ST.GridConteiner>
                <ST.DataLink href='https://movix.ru/services'>Смотреть все подписки</ST.DataLink>
            </ST.SubscriptionWrapper>
    );
};
